'use client';
import { createContext } from 'react';
import { AuthConfig } from '@aws-amplify/core';
import { PPCognitoUser } from '../../types/pp-user-attribute-types';

export interface PPAuthContextType {
  methods: {
    handleOauthSignedIn: () => void;
    handleOauthSignedOut: () => void;
  };
  userState: {
    user?: PPCognitoUser;
    roles?: string[];
    refreshToken?: string;
    idToken?: string;
    accessToken?: string;
    isAuthenticated: boolean | null;
    checkAuthStatus: () => Promise<void>;
  };
  config: AuthConfig;
}

export const PPAuthContext = createContext<PPAuthContextType | undefined>(
  undefined,
);
